import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Helmet } from "react-helmet";

const Layout = ({ children, title, description, keywords, author }) => {
  return (
    <>

<Helmet>
        <meta charset="UTF-8" />
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
        <title>{title}</title>
      </Helmet>
      <Header />

      <main>{children}</main>

      <Footer />
    </>
  );
};


Layout.defaultProps = {
  title: "Homepage",
  description: "Description will be here",
  keywords: "keywords will be here",
  author: "author will be here",
};

export default Layout;
